import { render, staticRenderFns } from "./RoomDetail.vue?vue&type=template&id=851e9e8a&scoped=true"
import script from "./RoomDetail.vue?vue&type=script&lang=js"
export * from "./RoomDetail.vue?vue&type=script&lang=js"
import style0 from "./RoomDetail.vue?vue&type=style&index=0&id=851e9e8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851e9e8a",
  null
  
)

export default component.exports